import {Col, Row} from "react-bootstrap";
import React, {memo, useEffect, useState} from "react";
import moment from "moment";

function AppWebReportStundenKostenschaetzung(props) {

    const [materialCost, setMaterialCost] = useState("")
    const [vorhaltungCost, setVorhaltungCost] = useState("")
    const [nebenCost, setNebenCost] = useState("")
    const [fahrtCost, setFahrtCost] = useState("")
    const [ustdCost, setUstdCost] = useState("")
    const [frist, setFrist] = useState("")


    useEffect(() => {
        if(props.kosten===undefined){
            setMaterialCost("")
        setVorhaltungCost("")
        setNebenCost("")
        setFahrtCost("")
        setUstdCost("")
        setFrist(moment().format("YYYY-MM-DD"))
        }
        else{
            setMaterialCost(props.kosten.material)
        setVorhaltungCost(props.kosten.vorhaltung)
        setNebenCost(props.kosten.neben)
        setFahrtCost(props.kosten.fahrt)
        setUstdCost(props.kosten.ueberstunden)
        setFrist(moment(props.kosten.frist).format("YYYY-MM-DD"))
        }
        }, [props.kosten]);


    return (<>
        <div>
            <Row>

                <Col sm={12}>
                    <label className="handwai-text-label-main">
                        {"Kostenschätzung"}
                    </label>
                </Col>
            </Row>
            <br/>

            <Row>
                <Col sm={11}>
                    <Row>

                        <Col sm={1} style={{marginRight:-90}}>
                            <label style={{width: "50%", whiteSpace: "nowrap"}}
                                   className="handwai-text-label-normal"> Material </label>
                        </Col>
                        <Col sm={1} >

                            <input type="text"
                                   style={{
                                       width: "90%", boxSizing: "border-box"
                                   }}
                                   disabled={true}
                                   value={materialCost}
                                   />

                            <label style={{width: "10%", whiteSpace: "nowrap", fontSize: 23}}
                                   className="handwai-text-label-normal">€</label>

                        </Col>


                        <Col sm={1} style={{marginLeft:105,marginRight:-70}}>
                            <label style={{width: "50%", whiteSpace: "nowrap"}}
                                   className="handwai-text-label-normal"> Vorhaltung</label>
                        </Col>
                        <Col sm={1}>
                            <input type="text"
                                   style={{
                                       width: "90%", boxSizing: "border-box"
                                   }}
                                   disabled={true}
                                   value={vorhaltungCost}
                                   />
                            <label style={{width: "10%", whiteSpace: "nowrap", fontSize: 23}}
                                   className="handwai-text-label-normal">€</label>

                        </Col>


                        <Col sm={1} style={{marginLeft:105,marginRight:-100}}>
                            <label style={{width: "50%", whiteSpace: "nowrap"}}
                                   className="handwai-text-label-normal"> Neben </label>
                        </Col>
                        <Col sm={1}>
                            <input type="text"
                                   style={{
                                       width: "90%", boxSizing: "border-box"
                                   }}
                                   disabled={true}
                                   value={nebenCost}/>
                            <label style={{width: "10%", whiteSpace: "nowrap", fontSize: 23}}
                                   className="handwai-text-label-normal">€</label>
                        </Col>


                        <Col sm={1} style={{marginLeft:105,marginRight:-100}}>
                            <label style={{width: "50%", whiteSpace: "nowrap"}}
                                   className="handwai-text-label-normal"> Fahrt </label>
                        </Col>
                        <Col sm={1} >
                            <input type="text"
                                   style={{
                                       width: "90%", boxSizing: "border-box"
                                   }}
                                   disabled={true}
                                   value={fahrtCost}
                                   />
                            <label style={{width: "10%", whiteSpace: "nowrap", fontSize: 23}}
                                   className="handwai-text-label-normal">€</label>
                        </Col>

                        <Col sm={1} style={{marginLeft:105,marginRight:-100}}>
                            <label style={{width: "50%", whiteSpace: "nowrap"}}
                                   className="handwai-text-label-normal"> Ü.std </label>
                        </Col>
                        <Col sm={1}>
                            <input type="text"
                                   style={{
                                       width: "90%", boxSizing: "border-box"
                                   }}
                                   disabled={true}
                                   value={ustdCost}
                            />
                            <label style={{width: "10%", whiteSpace: "nowrap", fontSize: 23}}
                                   className="handwai-text-label-normal">%</label>
                        </Col>

                        <Col sm={1} style={{marginLeft:105,marginRight:-100}}>
                            <label
                                style={{width: "50%", whiteSpace: "nowrap"}}
                                className="handwai-text-label-normal"> Frist </label>
                        </Col>
                        <Col sm={1} >
                            <input type="date"
                                   disabled={true}
                                   value={frist}
                                   />
                        </Col>
                    </Row>
                </Col>


            </Row>
        </div>
    </>)
}

export default memo(AppWebReportStundenKostenschaetzung)